<template>
  <BEditor
    :validate="validate"
    :value="valueHTML"
    placeholder="Введите формулу*"
    data-vv-as="«Введите формулу»"
    :disabled="disabled"
    :skeleton="skeleton"
    :extensions="extensions"
    :name="name"
    actions-left-side
    dense
    @input="onInput"
  />
</template>

<script>
import { ExcelCell } from '@/components/forms/BEditor.vue'


const BEditor = () => import(
  /* webpackChunkName: "BEditor" */
  '@/components/forms/BEditor.vue'
)

const createExtensions = ({ currentSheet, currentCell, sheetTree }) => [
  new ExcelCell({
    currentSheet,
    currentCell,
    sheetTree,
  }),
]

const fromHTML = (text) => text && text
  .replace(/cell_uuid="(.+?)"/g, 'cell_uuid="[#$_$1#]"')
  .replace(/<excel_cell.+?cell_uuid="(.+?)".+?>/g, '$1')
  .replace(/<p>(.*)<\/p>/g, '$1')
  .replace(/\s/g, '')

const toHTML = (text) => text && text
  .replace(/\[#\$_(.+?)#\]/g, '<excel_cell cell_uuid="$1"></excel_cell>')
  .replace(/(.*)/, '<p>$1</p>')

export default {
  name: 'FormTemplatesFormCellTypeFormula',
  inject: [
    '$validator',
  ],
  components: {
    BEditor,
  },
  props: {
    validate: [String, Object],
    disabled: Boolean,
    skeleton: Boolean,
    value: null,
    name: String,
    sheetTree: {
      type: Object,
      required: true,
    },
    currentSheet: {
      type: Object,
      required: true,
    },
    currentCell: {
      type: Object,
      required: true,
    },
  },
  computed: {
    extensions() {
      const options = {
        sheetTree: this.sheetTree,
        currentSheet: this.currentSheet,
        currentCell: this.currentCell,
      }
      return createExtensions(options)
    },
    valueHTML() {
      return toHTML(this.value)
    },
  },
  methods: {
    onInput(e) {
      const value = fromHTML(e)
      this.$emit('input', value)
    },
  },
}
</script>
